import * as React from "react";
import Header from "./Header";
import Footer from "./Footer";
import AppRouter from "../routing/AppRouter";
import ToastNotification from "./ToastNotification";
import { refreshIfNeeded } from "../../utils/authHelpers";

interface AppProps {
  title: string;
}

const App = () => {
  React.useEffect(() => {
    refreshIfNeeded(); // run once on app start

    const interval = setInterval(refreshIfNeeded, 1000 * 60 * 60); // every 1 hour
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col justify-between min-h-screen">
      <ToastNotification />
      <div className="flex-grow">
        <AppRouter />
      </div>
      <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};

export default App;
